<template>
  <div class="big-box">
    <div class="big-data-title">智慧加油站大数据效能分析</div>
    <div class="big-data-mian">
      <div class="big-data-main-left">
        <!--门店会员信息详情-->
        <div class="big-data-store">
          <div class="big-data-store-title">
            <div class="big-data-title-bg">门店会员信息详情</div>
          </div>
          <ul class="big-data-store-main">
            <li v-for="(item, idx) in store_info" :key="idx">
              <span>{{ item.name }}</span>
              <span class="store-text-color">{{ item.num }}</span>
            </li>
          </ul>
        </div>
        <!--会员消费排行榜-->
        <div class="big-data-main-user">
          <div class="big-data-store">
            <div class="big-data-store-title">
              <div class="big-data-title-bg">会员消费排行榜</div>
            </div>
            <table class="rank-list-con">
              <div class="rank-list-title" style="padding-left:15%">
                <span v-for="item in userRank" :key="item">{{ item }}</span>
              </div>
              <tr
                v-for="(item, idx) in userRankList"
                :key="idx"
                class="list-item"
              >
                <span style="color:rgba(97, 255, 76, 1)">{{ idx + 1 }}</span>
                <td>{{ item.name }}</td>
                <td>￥{{ item.money }}</td>
                <td>{{ item.type }}</td>
                <td style="margin-right:20px">{{ item.num }} 次</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="big-data-main-right">
        <div class="big-data-main-right-top">
          <div class="big-data-main-center">
            <div class="main-center-item">
              <span class="main-center-item-title">今日销售额</span>
              <div class="main-center-item-con">
                <span>3989.39</span>
                <span>元</span>
              </div>
            </div>
            <div class="main-center-item">
              <span class="main-center-item-title">今日加油量</span>
              <div class="main-center-item-con">
                <span>3010</span>
                <span>L</span>
              </div>
            </div>
            <div class="main-center-item">
              <span class="main-center-item-title">单数</span>
              <div class="main-center-item-con">
                <span>3989.39</span>
                <span>单</span>
              </div>
            </div>
            <div class="main-center-item" v-for="item in 6" :key="item">
              <span class="main-center-item-title">92汽油1号枪</span>
              <div class="main-center-item-con">
                <span>80</span>
                <span>L</span>
              </div>
            </div>
          </div>
          <!--加油员排行-->
          <div class="big-data-main-user">
            <div class="big-data-store">
              <div class="big-data-store-title">
                <div class="big-data-title-bg">加油员排行榜</div>
              </div>
              <table class="rank-list-con">
                <div class="rank-list-title">
                  <span v-for="item in tankerRank" :key="item">{{ item }}</span>
                </div>
                <tr
                  v-for="(item, idx) in tankerList"
                  :key="idx"
                  class="list-item"
                >
                  <span style="color:rgba(97, 255, 76, 1)">{{ idx + 1 }}</span>
                  <td>{{ item.name }}</td>
                  <td>{{ item.money }}</td>
                  <td>{{ item.type }}</td>
                  <td>{{ item.end_time }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div class="data-eacher">
          <div class="data-eacher-money">
            <div class="big-data-store-title">
              <div class="big-data-title-bg">油品销售额和升数</div>
            </div>
            <div id="mydata"></div>
          </div>
          <div class="data-eacher-paytype">
            <div class="big-data-store-title">
              <div class="big-data-title-bg">收款支付方式</div>
            </div>
            <div id="mypay"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
export default {
  data() {
    return {
      store_info: [
        {
          name: "会员数",
          num: 50
        },
        {
          name: "今日客流数",
          num: 150
        },
        {
          name: "新增会员",
          num: 250
        },
        {
          name: "本月已消费会员数",
          num: 20
        },
        {
          name: "本月未消费会员数",
          num: 10
        },
        {
          name: "新增会员",
          num: 250
        },
        {
          name: "本月已消费会员数",
          num: 20
        },
        {
          name: "本月未消费会员数",
          num: 10
        }
      ],
      tankerRank: ["加油员", "金额", "抢号", "截止时间"],
      tankerList: [
        {
          name: "张三",
          money: "150",
          end_time: "2018/04/04",
          type: "6号枪"
        },
        {
          name: "张三",
          money: "150",
          end_time: "2018/04/04",
          type: "6号枪"
        },
        {
          name: "张三",
          money: "150",
          end_time: "2018/04/04",
          type: "6号枪"
        },
        {
          name: "张三",
          money: "150",
          end_time: "2018/04/04",
          type: "6号枪"
        },
        {
          name: "张三",
          money: "150",
          end_time: "2018/04/04",
          type: "6号枪"
        },
        {
          name: "张三",
          money: "150",
          end_time: "2018/04/04",
          type: "6号枪"
        },
        {
          name: "张三",
          money: "150",
          end_time: "2018/04/04",
          type: "6号枪"
        },
        {
          name: "张三",
          money: "150",
          end_time: "2018/04/04",
          type: "6号枪"
        }
      ],
      userRank: ["姓名", "消费额度", "油品", "加油次数"],
      userRankList: [
        {
          name: "张三",
          money: "150",
          num: "10",
          type: "#92"
        },
        {
          name: "张三",
          money: "150",
          num: "10",
          type: "#92"
        },
        {
          name: "张三",
          money: "150",
          num: "10",
          type: "#92"
        },
        {
          name: "张三",
          money: "150",
          num: "10",
          type: "#92"
        },
        {
          name: "张三",
          money: "150",
          num: "10",
          type: "#92"
        },
        {
          name: "张三",
          money: "150",
          num: "10",
          type: "#92"
        }
      ],
      option_1: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow',
          }
        },
        textStyle: {
          color: "#ffffff"
        },
        legend: {
          data: ["销售额", "剩余油量"],
          textStyle: {
            color: "#ffffff"
          }
        },
        color: ["#00FFFF", "#02FF67"],
        grid: {
          left: "3%",
          right: "4%",
          bottom: "20%",
          containLabel: true,
          textStyle: {
            color: "#ffffff"
          }
        },
        xAxis: [
          {
            type: "category",
            data: [
              "1号油枪",
              "2号油枪",
              "3号油枪",
              "4号油枪",
              "5号油枪",
              "6号油枪"
            ],
            lineStyle: {
              color: "#ffffff"
            }
          }
        ],
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            name: "销售额",
            type: "bar",
            data: [320, 332, 301, 334, 390, 330, 320]
          },
          {
            name: "剩余油量",
            type: "bar",
            data: [120, 132, 101, 134, 90, 230, 210]
          }
        ]
      },
      option_2: {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          data: ["微信支付", "支付宝支付", "银行卡支付"],
          right: 10,
          top: 20,
          bottom: 20,
          textStyle: {
            color: "#ffffff"
          }
        },
        grid: {
          top: 0
        },
        series: [
          {
            name: "支付方式",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "24",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: 335, name: "微信支付" },
              { value: 310, name: "支付宝支付" },
              { value: 1548, name: "银行卡支付" }
            ]
          }
        ]
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initEachers();
    });
  },
  methods: {
    initEachers() {
      const el_one = echarts.init(document.getElementById("mydata"));
      const el_two = echarts.init(document.getElementById("mypay"));
      if (this.option_1 && typeof this.option_1 === "object") {
        el_one.setOption(this.option_1, true);
      }
      if (this.option_2 && typeof this.option_2 === "object") {
        el_two.setOption(this.option_2, true);
      }
    }
  }
};
</script>
<style lang="scss">
$hieght: 492px;
@mixin box-title {
  .big-data-store-title {
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: rgba(8, 48, 74, 1);
    .big-data-title-bg {
      letter-spacing: 2px;
      font-size: 16px;
      padding-left: 14px;
      font-weight: bold;
      color: rgba(0, 229, 255, 1);
      background: rgba(1, 86, 152, 0.1);
      background-blend-mode: overlay;
    }
  }
}
@mixin rank($hieght) {
  .big-data-main-user {
    width: 473px;
    height: $hieght;
    background: rgba(1, 51, 102, 0.4);
    border: 1px solid rgba(1, 51, 102, 1);
    @include box-title;
    .rank-list-con {
      width: 98%;
      height: auto;
      margin: 0;
      padding: 0;
      border: none;
      display: flex;
      flex-direction: column;
      .rank-list-title {
        width: 100%;
        height: 58px;
        color: #fff;
        line-height: 58px;
        padding-left: 10%;
        border-bottom: 1px solid rgba(0, 118, 180, 0.5);
        span:nth-child(2) {
          padding-left: 16%;
        }
        span:nth-child(3) {
          padding-left: 18%;
        }
        span:nth-child(4) {
          padding-left: 14%;
        }
      }
      .list-item {
        width: 100%;
        color: #fff;
        height: 48px;
        align-items: center;
        display: flex;
        box-sizing: border-box;
        padding: 0 10px 0 20px;
        justify-content: space-between;
        td {
          flex: 1;
          font-size: 14px;
          font-weight: 400;
          color: #00e5ff;
          display: inline-block;
          text-align: center;
        }
      }
    }
  }
}

.big-box {
  width: 100%;
  height: 100vh;
  padding: 0px 28px;
  box-sizing: border-box;
  overflow: hidden;
  background: center/100% url("../../../assets/images/data-bg.png");
  .big-data-title {
    width: 100%;
    height: 105px;
    line-height: 105px;
    font-size: 28px;
    font-weight: normal;
    font-family: Adobe Heiti Std;
    color: rgba(0, 204, 255, 1);
  }
  .big-data-mian {
    width: 100%;
    height: 100%;
    display: flex;
    .big-data-main-left {
      width: 475px;
      max-width: 475px;
      .big-data-store {
        width: 100%;
        height: auto;
        display: flex;
        box-sizing: border-box;
        border: 1px solid rgba(0, 118, 180, 0.2);
        background: rgba(1, 51, 102, 0.3);
        flex-direction: column;
        @include box-title;
        .big-data-store-main {
          width: 98%;
          display: flex;
          flex-direction: column;
          li {
            color: rgba(0, 229, 255, 1);
            height: 48px;
            line-height: 48px;
            display: flex;
            font-size: 14px;
            text-align: left;
            padding: 0 0px 0 12px;
            justify-content: space-between;
            border-bottom: 1px solid rgba(0, 118, 180, 0.5);
            &:last-child {
              border-bottom: none;
            }
            .store-text-color {
              width: 80px;
              display: inline-block;
              text-align: left;
              color: rgba(97, 255, 76, 1);
            }
          }
        }
      }
      @include rank(calc(100% - 540px));
      .big-data-main-user {
        margin-top: 10px;
      }
    }
    .big-data-main-right {
      flex: 1;
      height: 90%;
      margin-left: 10px;
      display: flex;
      flex-wrap: wrap;
      .big-data-main-right-top {
        width: 100%;
        height: auto;
        display: flex;
        .big-data-main-center {
          width: 98%;
          background: rgba(1, 51, 102, 0.4);
          border: 1px solid rgba(1, 51, 102, 1);
          display: flex;
          justify-content: flex-start;
          padding: 90px 0 0 80px;
          flex-wrap: wrap;
          .main-center-item {
            width: 32%;
            display: flex;
            color: #00e5ff;
            flex-direction: column;
            .main-center-item-title {
              color: #ffffff;
              font-size: 18px;
              font-weight: 400;
            }
            .main-center-item-con {
              color: #00e5ff;
              font-size: 40px;
              margin-top: 18px;
              font-weight: 400;
              span:nth-child(2) {
                font-size: 14px;
                font-family: "Times New Roman";
                margin-left: 20px;
              }
            }
          }
        }
        @include rank(529px);
        .big-data-main-user {
          margin-left: 10px;
        }
      }
      .data-eacher {
        width: 100%;
        height: 30%;
        min-height: 320px;
        display: flex;
        margin-top: 15px;
        .data-eacher-money {
          width: 65%;
          height: 100%;
          background: rgba(1, 51, 102, 0.3);
          @include box-title;
          #mydata {
            width: 100%;
            height: 100%;
          }
        }
        .data-eacher-paytype {
          flex: 1;
          height: 100%;
          margin-left: 15px;
          background: rgba(1, 51, 102, 0.3);
          @include box-title;
          #mypay {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
